import { render, staticRenderFns } from "./kv-tooltip.vue?vue&type=template&id=81c2857a"
import script from "./kv-tooltip.vue?vue&type=script&lang=js"
export * from "./kv-tooltip.vue?vue&type=script&lang=js"
import style0 from "./kv-tooltip.vue?vue&type=style&index=0&id=81c2857a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports